import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";

import config from "@app/config";
import { GeolocationDrawer, GeolocationDrawerProps } from "@app/scripts/react-geolocation/components/GeolocationDrawer";
import { GeolocationPopup, GeolocationProps } from "@app/scripts/react-geolocation/components/GeolocationPopup";
import { LocalisationObject } from "../types";

const detectCountry = async () => {
  const res = await axios.get("/browsing_context_suggestions.json");
  const detectedCountry = res?.data?.detected_values?.country?.handle;
  localStorage.setItem("detectedCountry", res?.data?.detected_values?.country?.handle);
  return detectedCountry;
};

const GeolocationElem = class extends HTMLElement {
  async connectedCallback() {
    const cachedResult = localStorage.getItem("detectedCountry");
    let props = {} as GeolocationProps;

    try {
      props = JSON.parse(this.querySelector("[data-json]")?.innerHTML);
    } catch (error) {
      console.error(error);
    }

    const shop = Shopify.shop.split(".myshopify")[0];
    const storeConfig = config.stores[shop];

    if (storeConfig) {
      const detectedCountry = cachedResult || (await detectCountry());
      const isNorthAmerica = ["CA", "US", "MX"].includes(detectedCountry);
      const unitedKingdom = detectedCountry === "GB";
      const newZealand = detectedCountry === "NZ";

      props.storeConfig = storeConfig;
      props.shouldOpenPopup =
        !unitedKingdom &&
        ((isNorthAmerica && !newZealand && storeConfig.region === "AU") ||
          (!isNorthAmerica && storeConfig.region === "US")) &&
        sessionStorage.getItem("geoPopupClosed") !== "true";

      const root = ReactDOM.createRoot(this);
      root.render(<GeolocationPopup {...props} />);
    }
  }
};

customElements.define("geolocation-popup", GeolocationElem);

const GeolocationDrawerElem = class extends HTMLElement {
  async connectedCallback() {
    let props = {} as GeolocationDrawerProps;

    const storeConfig = config.stores[Shopify.shop.split(".myshopify")[0]];

    try {
      const localisation: LocalisationObject = JSON.parse(document.querySelector("[data-localisation]")?.innerHTML);
      props = {
        localisation,
      };
    } catch (error) {
      console.error(error);
    }

    if (storeConfig) {
      props.storeConfig = storeConfig;
      const root = ReactDOM.createRoot(this);
      root.render(<GeolocationDrawer {...props} />);
    }
  }
};

customElements.define("geolocation-drawer", GeolocationDrawerElem);
